import React, { Component } from 'react'
import SitesList from '../../components/sites/SitesList'

class SitesManagerPage extends Component {
  render() {
    return (
      <div>
        <SitesList/>
      </div>
    )
  }
}

export default SitesManagerPage